import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../locales/messages';
import './InstanaROI.scss';
import { ThanksProps } from './Thanks';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { DocumentPdf32 } from '@carbon/icons-react';

const ThanksDetails = ({
  disruptions,
  preventions,
  speedGain,
  avgTime,
  itOpsEmployees,
  developers,
  developerEffiencyGains,
  itOpsEffiencyGains,
  openSourceGains,
  totalEffiencyGains,
  openSourceTechnoList,
  pdfObject,
  pdfExport,
}: ThanksProps): ReactElement => {
  return (
    <div className="thanks__requirement thanks__pad4">
      <FormattedMessage {...messages.chart_label_summary_1} />:
      <strong>{` ${disruptions}`}</strong>
      <br />
      <FormattedMessage {...messages.chart_label_summary_2} />:
      <strong>{` ${avgTime}`}</strong>
      <br />
      <FormattedMessage {...messages.chart_label_summary_3} />:
      <strong>{` ${developers}`}</strong>
      <br />
      <FormattedMessage {...messages.chart_label_summary_4} />:
      <strong>{` ${itOpsEmployees}`}</strong>
      <br />
      <FormattedMessage {...messages.chart_label_summary_5} />:
      <strong>{` ${openSourceTechnoList}`}</strong>
      <br />
      <FormattedMessage {...messages.label_1} />:
      <strong>{` ${preventions}`}</strong>
      <br />
      <FormattedMessage {...messages.label_2} />:
      <strong>{` ${speedGain}`}</strong>
      <br />
      <FormattedMessage {...messages.label_3} />:
      <strong>{` ${developerEffiencyGains}`}</strong>
      <br />
      <FormattedMessage {...messages.label_4} />:
      <strong>{` ${itOpsEffiencyGains}`}</strong>
      <br />
      <FormattedMessage {...messages.label_6} />:
      <strong>{` ${openSourceGains}`}</strong>
      <br />
      <FormattedMessage {...messages.page_heading_total} />:
      <strong>{` ${totalEffiencyGains}`}</strong>
      <br />
      {pdfExport && pdfObject ? (
        <PDFDownloadLink
          document={pdfObject}
          fileName={`mas_bva_${new Date()}.pdf`}
        >
          <FormattedMessage {...messages.downloadText} />
          <DocumentPdf32 className="load_icon" />
        </PDFDownloadLink>
      ) : null}
    </div>
  );
};

export default ThanksDetails;
